// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"288":"b65f38dd","379":"85f5433e","505":"b89abaaf","514":"76597e42","608":"fe1d852e","613":"0b6ba3ea","787":"4ce86b6b","931":"4a4dcf23"}[chunkId] + ".chunk.css";
};